import { NotFoundPage } from "src/pages/NotFound";

export default NotFoundPage;
